import { styleOverrides } from "./styleOverrides";

const MuiTab = {
  styleOverrides,
};

export { MuiTab };
